'use client';

import { LoaderButton } from '@/components/ui/loader-button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { openGlobalSearch } from '@/lib/global-search-v2/open-event';
import { FunnelIcon } from 'lucide-react';
import { useGlobalFilterItems } from '../hooks/use-global-filter-items';
import { FILTER_TYPE_LABEL } from '../utils';

/** Enough rows to recognise the scope; beyond that the tooltip is a wall of
 *  names and the filter page is the better place to look. */
const TOOLTIP_ITEMS = 6;

/** Opens the filter page. The dot marks that the system is scoped; the tooltip
 *  and label say by how much. */
export function GlobalFilterTrigger() {
  const { data, isLoading } = useGlobalFilterItems();
  const items = data ?? [];
  const count = items.length;
  const label = count
    ? `Filtrera systemet — ${count} aktiva filter`
    : 'Filtrera systemet';

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className='relative shrink-0'>
          <LoaderButton
            variant='outline'
            className='size-10'
            onClick={() => openGlobalSearch({ page: 'filter' })}
            isLoading={isLoading}
            aria-label={label}
          >
            <FunnelIcon className='size-4 shrink-0' />
          </LoaderButton>
          {count > 0 && (
            <span className='absolute -top-1 -right-1 size-3 rounded-full bg-primary' />
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent className='max-w-64 py-2'>
        {label}
        {count > 0 && (
          <ul className='mt-1.5 flex flex-col gap-1 text-xs'>
            {items.slice(0, TOOLTIP_ITEMS).map((item) => (
              <li key={`${item.type}-${item.id}`} className='flex gap-1.5'>
                <span className='shrink-0 text-muted-foreground'>
                  {FILTER_TYPE_LABEL[item.type]}
                </span>
                <span className='truncate'>{item.displayString}</span>
              </li>
            ))}
            {count > TOOLTIP_ITEMS && (
              <li className='text-muted-foreground'>
                +{count - TOOLTIP_ITEMS} fler
              </li>
            )}
          </ul>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
